import { useParams, Link } from "react-router-dom";

// ✅ Strong typing with index signature for dynamic access
const jobData: {
  [key: string]: {
    title: string;
    location: string;
    description: string;
    responsibilities: string[];
    qualifications: string[];
  };
} = {
  "account-exec": {
    title: "Account Executive",
    location: "Remote / US",
    description:
      "As an Account Executive, you'll be the front line for helping restaurants onboard and grow with FullPlateNow.",
    responsibilities: [
      "Manage inbound restaurant leads",
      "Close new accounts and grow revenue",
      "Work cross-functionally with onboarding + support",
    ],
    qualifications: [
      "2+ years sales experience",
      "Strong communication and empathy",
      "Knowledge of food tech a plus",
    ],
  },
  "fullstack-dev": {
    title: "Full-Stack Developer",
    location: "Remote / North America",
    description:
      "You'll help build the core web + mobile experience powering our restaurant platform.",
    responsibilities: [
      "Write clean, scalable React + Django code",
      "Design and implement backend APIs",
      "Collaborate with product and design teams",
    ],
    qualifications: [
      "3+ years full-stack experience",
      "React, Tailwind, Django expertise",
      "Experience shipping production code",
    ],
  },
  "support-specialist": {
    title: "Restaurant Support Specialist",
    location: "Remote / Flexible",
    description:
      "Be the voice of FullPlateNow for our restaurant partners, helping them thrive on our platform.",
    responsibilities: [
      "Respond to restaurant support tickets",
      "Troubleshoot menu syncs and delivery issues",
      "Collaborate with dev + onboarding teams",
    ],
    qualifications: [
      "Customer service experience",
      "Strong problem-solving",
      "Comfort with food/delivery tech",
    ],
  },
};

const JobDetail = () => {
  const { id } = useParams();
  const job = id ? jobData[id] : null;

  if (!job) return <div className="p-6">Job not found.</div>;

  return (
    <div className="bg-white text-black px-6 py-16 max-w-3xl mx-auto font-sans">
      <Link
        to="/careers"
        className="text-sm text-[#FF5A5F] underline mb-4 inline-block"
      >
        ← Back to careers
      </Link>

      <h1 className="text-3xl font-bold mb-2">{job.title}</h1>
      <p className="text-sm text-black/60 mb-6">{job.location}</p>
      <p className="text-lg mb-8">{job.description}</p>

      <h2 className="text-xl font-semibold mb-2">Responsibilities</h2>
      <ul className="list-disc list-inside mb-6 space-y-1">
        {job.responsibilities.map((r: string, i: number) => (
          <li key={i}>{r}</li>
        ))}
      </ul>

      <h2 className="text-xl font-semibold mb-2">Qualifications</h2>
      <ul className="list-disc list-inside mb-8 space-y-1">
        {job.qualifications.map((q: string, i: number) => (
          <li key={i}>{q}</li>
        ))}
      </ul>

      <button className="bg-[#FF5A5F] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#e04f55] transition">
        Apply Now
      </button>
    </div>
  );
};

export default JobDetail;
